var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0088 1V12.0006L13.9992 8.85757",
    stroke: "#2F80ED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.009 11.998L8.01855 8.85498",
    stroke: "#2F80ED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.0015H5.41024C5.79026 12.0015 6.13028 12.2115 6.30029 12.5515L7.47035 14.8916C7.81037 15.5717 8.50041 16.0017 9.26045 16.0017H12.7906C13.5507 16.0017 14.2407 15.5717 14.5807 14.8916L15.7508 12.5515C15.9208 12.2115 16.2708 12.0015 16.6409 12.0015H21.0011",
    stroke: "#2F80ED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0198 3.12891C2.47961 3.64893 1.01953 5.72905 1.01953 9.99928V13.9995C1.01953 18.9998 3.01964 20.9999 8.01991 20.9999H14.0202C19.0205 20.9999 21.0206 18.9998 21.0206 13.9995V9.99928C21.0206 5.72905 19.5605 3.64893 16.0204 3.12891",
    stroke: "#2F80ED",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.8652aa0ac84b9b3b682d8f506718eb60.svg";
export { ForwardRef as ReactComponent };